<template>
  <boxwrap class="transfers--inner">
    <toolbar>
      <toolbar-items class="-seachbar">
        <select-list
          ref="toolbarNav"
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedStatus"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>All</span>
          </select-option>

          <select-option
            value="confirmed"
            name="confirmed"
          >
            <span>confirmed</span>
          </select-option>

          <select-option
            value="pending"
            name="pending"
          >
            <span>pending</span>
          </select-option>

          <select-option
            value="rejected"
            name="rejected"
          >
            <span>rejected</span>
          </select-option>

          <select-option
            value="waiting"
            name="waiting"
          >
            <span>waiting</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap -withdropdown"
          :filterBy="filterBy"
          :dateBy="dateBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>

        <button
          class="btn--modify"
          title="save"
          @click="update()"
          v-if="selected.length > 0"
        >
          <i class="ico--save"></i>
        </button>

        <button
          class="btn--modify"
          title="modify"
          @click="updateAll('C')"
          v-if="selected.length"
        >
          confirm
        </button>

        <button
          class="btn--create"
          title="waiting"
          @click="updateAll('W')"
          v-if="selected.length"
        >
          waiting
        </button>

        <button
          class="btn--delete"
          title="modify"
          @click="updateAll('R')"
          v-if="selected.length"
        >
          reject
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="checkbox"
              >
              <checkbox>
                <input
                  type="checkbox"
                  @click="checkAll(transfers)"
                  :checked="selectAll"
                />
              </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              >
                <span>no</span>
              </tbl-td>

              <tbl-td
                class="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                <span>created at</span>
              </tbl-td>

              <tbl-td
                name="login-id"
                :sort="true"
                @click.native="sort('login_id')"
                v-if="checkCol('login_id', tblSetting)"
              >
                <span>login id</span>
              </tbl-td>

              <tbl-td
                name="login-name"
                :sort="true"
                @click.native="sort('login_name')"
                v-if="checkCol('login_name', tblSetting)"
              >
                <span>login name</span>
              </tbl-td>

              <tbl-td
                name="level"
                :sort="true"
                @click.native="sort('level_id')"
                v-if="checkCol('level', tblSetting)"
              >
                <span>level</span>
              </tbl-td>

              <tbl-td
                name="agent"
                :sort="true"
                @click.native="sort('agents.login_id')"
                v-if="checkCol('agent', tblSetting)"
              >
                <span>agent</span>
              </tbl-td>

              <tbl-td
                name="type"
                :sort="true"
                @click.native="sort('type_id')"
                v-if="checkCol('type', tblSetting)"
              >
                <span>type</span>
              </tbl-td>

              <tbl-td
                name="before-transfer"
                :sort="true"
                @click.native="sort('old_balance')"
                v-if="checkCol('old_balance', tblSetting)"
              >
                <span>before-transfer</span>
              </tbl-td>

              <tbl-td
                name="new-balance"
                :sort="true"
                @click.native="sort('new_balance')"
                v-if="checkCol('old_balance', tblSetting)"
              >
                <span>new-balance</span>
              </tbl-td>

              <tbl-td
                name="amount"
                :sort="true"
                @click.native="sort('amount')"
                v-if="checkCol('amount', tblSetting)"
              >
                <span>amount</span>
              </tbl-td>

              <tbl-td
                name="user-money"
                :sort="true"
                @click.native="sort('users.amount')"
                v-if="checkCol('user_money', tblSetting)"
              >
                <span>user-money</span>
              </tbl-td>

              <tbl-td
                name="status"
                :sort="true"
                @click.native="sort('status')"
                v-if="checkCol('status', tblSetting)"
              >
                <span>status</span>
              </tbl-td>

              <tbl-td
                class="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                <span>updated at</span>
              </tbl-td>

              <tbl-td
                class="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                <span>deleted at</span>
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(transfer, x) in transfers"
              :key="transfer.id"
            >
              <tbl-td
                class="checkbox"
              >
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="transfer.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('id', tblSetting)"
              >
                <span> {{ generateNumber(x, params.page, params.rows, params.sort, listCount || 0) }} </span>
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                <span>{{ transfer.created_at | date }}</span>
              </tbl-td>

              <tbl-td
                class="login-id"
                v-if="checkCol('login_id', tblSetting)"
                @click.native="openUser(transfer.user.id,  'info')"
              >
                <span>{{ transfer.user.login_id }}</span>
              </tbl-td>

              <tbl-td
                class="login-name"
                v-if="checkCol('login_name', tblSetting)"
              >
                <span>{{ transfer.user.login_name }}</span>
              </tbl-td>

              <tbl-td
                name="level"
                v-if="checkCol('level', tblSetting)"
              >
                <span>lvl.{{ transfer.user.level_id }}</span>
              </tbl-td>

              <tbl-td
                name="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                <span>{{ transfer.user.code.login_id }}</span>
              </tbl-td>

              <tbl-td
                class="type"
                v-if="checkCol('type', tblSetting)"
              >
                <span>{{ transfer.type_id | type }}</span>
              </tbl-td>

              <tbl-td
                class="before-transfer"
                v-if="checkCol('old_balance', tblSetting)"
              >
                <span>{{ transfer.old_balance | FormatAmount('whole') }}</span>
              </tbl-td>

              <tbl-td
                class="new-balance"
                v-if="checkCol('amount', tblSetting)"
              >
                <span>{{ transfer.new_balance | FormatAmount('whole') }}</span>
              </tbl-td>

              <tbl-td
                class="amount"
                v-if="checkCol('amount', tblSetting)"
              >
                <span>{{ transfer.amount | FormatAmount('whole') }}</span>
              </tbl-td>

              <tbl-td
                class="user-money"
                v-if="checkCol('user_money', tblSetting)"
              >
                <span>{{ transfer.user.amount | FormatAmount('whole') }}</span>
              </tbl-td>

              <tbl-td
                class="status"
                v-if="checkCol('status', tblSetting)"
              >
                <select-list
                  :title="transfer.status | status"
                  :withReset="true"
                  v-model="transfer.status"
                  ref="status"
                  v-if="transferList[x]
                    && (transferList[x].status.toLowerCase() === 'p'
                    || transferList[x].status.toLowerCase() === 'w')
                    && checkPermission"
                >
                  <select-option
                    v-for="s in transferStatus[transfer.id]"
                    :value="s"
                    :name="s | status"
                    :key="s"
                    @click.native="setSelected(transfer.id, 'status')"
                  >
                    {{ s | status }}
                  </select-option>
                </select-list>

                <span v-else>{{ transfer.status | status }}</span>

              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                <span
                  v-if="transferList[x] &&
                  transferList[x].status.toLowerCase() !== 'p' &&
                  transferList[x].status.toLowerCase() !== 'w'"
                >{{ transfer.updated_at | date }}</span>
                <span v-else>-</span>
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                <span>{{ transfer.deleted_at | date }}</span>
              </tbl-td>

            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="listCount"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { transfers } from '@/socket'
import { mapState, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'

//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  name: 'transfers-list',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList
  },

  mixins: [ getListStatus, checkAll, swal ],

  filters: {
    FormatAmount,

    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    },

    type (t) {
      let text = ''
      switch (t) {
        case 1:
        case 3:
          text = 'Cash in'
          break
        case 2:
        case 4:
          text = 'Cash out'
          break
      }

      return text
    }
  },

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc'
      },
      this.$route.query
    )

    for (const key in params) {
      if (params.hasOwnProperty(key) && !isNaN(parseFloat(params[key]))) {
        params[key] = parseFloat(params[key])
      }
    }

    return {
      params,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,
      showTblSettings: false,

      // selectedList: this.$route.params.status || 'all',

      selectAll: false,
      status: '',
      type: '',
      page: 1,
      stats: ['C', 'W', 'D', 'P', 'R'],
      transfers: [],
      selected: [],

      filterBy: [
        {
          value: 'login_id',
          display: 'login id'
        },
        {
          value: 'login_name',
          display: 'login name'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      tblSetting: 'transfer_list',
      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'agent',
          value: 'agent'
        },
        {
          display: 'type',
          value: 'type'
        },
        {
          display: 'old balance',
          value: 'old_balance'
        },
        {
          display: 'amount',
          value: 'amount'
        },
        {
          display: 'user money',
          value: 'user_money'
        },
        {
          display: 'status',
          value: 'status'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        }
      ]
    }
  },

  computed: {
    ...mapState('transfer', { transferList: 'transfers', listCount: 'count' }),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    transferStatus () {
      let status = {}

      this.transfers.forEach((e) => {
        switch (e.status.toLowerCase()) {
          case 'c':
            status[e.id] = ['P', 'W', 'B']
            break
          case 'w':
          case 'p':
            status[e.id] = ['C', 'R', 'W']
            break
          case 'b':
            status[e.id] = ['C']
            break
          case 'r':
            status[e.id] = ['P', 'W']
            break
        }
      })

      return status
    }
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.type = $router.params.type
      this.status = $router.params.status
      this.$refs.toolbarNav.selected.name = this.status
      this.search(this.generate($router.query))
    }
  },

  async created () {
    this.search()
  },

  mounted () {
    transfers.on('cash-in', async (data) => {
      if (this.$route.params.type === 'cashout') return

      data = JSON.parse(data)

      let test = JSON.parse(JSON.stringify(this.transferList))
      test.pop()
      test.unshift(data)
      this.SET_TRANSFERS(test)

      this.transfers = JSON.parse(JSON.stringify(this.transferList))
    })

    transfers.on('cash-out', async (data) => {
      if (this.$route.params.type === 'cashin') return

      data = JSON.parse(data)

      let test = JSON.parse(JSON.stringify(this.transferList))
      test.pop()
      test.unshift(data)
      this.SET_TRANSFERS(test)

      this.transfers = JSON.parse(JSON.stringify(this.transferList))
    })
  },

  beforeDestroy () {
    transfers.removeListener('cash-out')
    transfers.removeListener('cash-in')
  },

  methods: {
    ...mapActions('transfer', { getTransfers: 'get' }),
    ...mapActions('transfer', { patch: 'update' }),
    ...mapMutations('transfer', ['SET_TRANSFERS']),
    ...mapActions('meta', { getAllMeta: 'get', getCashInfo: 'getCashInfo' }),

    tempTotal (transfer) {
      if (transfer.status.toLowerCase() !== 'c') {
        return 0
      }
      if ([1, 3].indexOf(transfer.type_id) > -1) {
        return transfer.amount + transfer.old_balance
      }
      return transfer.old_balance - transfer.amount
    },

    async trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.type = this.$route.params.type
      this.status = this.$route.params.status

      this.params = query || this.params
      this.selected = []

      // == flag reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getTransfers({
        type: this.type || 'all',
        status: this.status || 'all',
        params: this.params
      })

      this.transfers = JSON.parse(JSON.stringify(this.transferList))

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.transfers.length) {
        this.isEmpty = true
      }
    },

    setSelected (id, type) {
      this.$nextTick(() => {
        let unchanged = this.transferList.find((e) => { return e.id === id })
        let changed = this.transfers.find((e) => { return e.id === id })
        // == validation for changed data
        if (changed[type] !== unchanged[type]) {
          // == pushing modified
          this.selected.push(id)
          this.selected = _.uniq(this.selected)
        } else {
          let index = this.selected.indexOf(id)
          if (index > -1) {
            // == removing item not edited if exists
            this.selected.splice(index, 1)
          }
        }
      })
    },

    async update () {
      let success = async () => {
        this.showDataLoading = true
        let edited = this.transfers.filter((e) => {
          return this.selected.indexOf(e.id) > -1
        })

        let stats = []
        for (var x = 0; x < edited.length; x++) {
          try {
            await this.patch({
              status: edited[x].status,
              id: edited[x].id,
              item: edited[x]
            })

            stats.push(parseInt(edited[x].type_id))
          } catch (err) {

          }
        }
        let path = ''
        if (_.uniq(stats).length > 1) {
          path = `/transfers/all/all`
        } else {
          let stat = stats[0] === 1 ? 'cashin' : 'cashout'
          path = `/transfers/${stat}/all`
        }

        if (this.$route.path !== path) {
          this.$router.push({ path })
          return
        }
        this.selectAll = false
        // await this.getAllMeta()
        // await this.getCashInfo()
        await this.search()
        this.showDataLoading = false

        if (!this.transfers.length) {
          this.isEmpty = true
        }
      }

      let cancel = async () => {
        let edited = this.transfers.filter((e) => {
          return this.selected.indexOf(e.id) > -1
        })

        for (var x = 0; x < this.transfers.length; x++) {
          if (this.selected.indexOf(this.transfers[x].id) > -1) {
            let edit = this.transferList.find((a) => {
              return a.id === this.transfers[x].id
            })
            this.transfers[x].status = edit.status
            this.$refs.status[0].reset = true
          }
        }
      }

      this.$alert('prompt', 'Are you sure you want to modify the following transaction(s)?', {},
        { success, cancel }, 'Modify Transaction')
    },

    updateAll (status) {
      let edited = this.transfers.filter((e) => {
        return this.selected.indexOf(e.id) > -1
      })

      edited = edited.filter((e, x) => {
        if (e.status.toLowerCase() === 'c' || e.status.toLowerCase() === 'r') {
          let f = this.transferList.find((trans) => { return trans.id === e.id })
          return f.status !== e.status
        }
        return e
      })

      if (!edited.length) {
        alert('no data to be changed')
        return
      }

      edited.forEach((e) => {
        e.status = status
      })

      this.selectAll = false
      this.update()
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({ query: this.params })
    },

    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }
}
</script>
